import ErrorAlert from "@/utility/ErrorAlert";
import http from "@/axios/http-common";
import { HandoverRequest, HandoverResponseItem } from "@/types/cppt";

async function create(data: HandoverRequest) {
  const response = await http.postData("/handover", data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function update(id, data: HandoverRequest) {
  const response = await http.putData(`/handover/${id}`, data).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function getByRegister(
  register_id: string | number
): Promise<{ status: number; data: HandoverResponseItem[] }> {
  const response = await http
    .getData(`/register/${register_id}/handover`)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function find(id: number) {
  const response = await http.getData(`/handover/${id}`).catch(err => {
    ErrorAlert.showErrorAlert(err);

    return Promise.reject(err);
  });

  return response.data.data;
}

async function destroy(id, alasan) {
  const response = await http
    .deleteDataParam(`/handover/${id}`, {
      params: {
        alasan: alasan
      }
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function verify(id, data = undefined) {
  const response = await http
    .postData(`/handover/${id}/verifikasi`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

async function approve(id, data = undefined) {
  const response = await http
    .postData(`/handover/${id}/approval`, data)
    .catch(err => {
      ErrorAlert.showErrorAlert(err);

      return Promise.reject(err);
    });

  return response.data;
}

export default {
  create,
  update,
  getByRegister,
  find,
  destroy,
  verify,
  approve
};
